const MICRO_UNIT_PREMIUM_THRESHOLD = 1_000_000_000_000;
const MICRO_UNIT_PREMIUM_DIVISOR = 1_000_000;

const normalizePremiumValue = (value: number): number => {
  if (Math.abs(value) >= MICRO_UNIT_PREMIUM_THRESHOLD) {
    return value / MICRO_UNIT_PREMIUM_DIVISOR;
  }

  return value;
};

const wholeDollarFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const formatWholeCurrency = (value: number): string =>
  `$${wholeDollarFormatter.format(normalizePremiumValue(value))}`;

function fmtCurrency(value: number): string {
  return formatWholeCurrency(value);
}

function fmtCurrencyFull(value: number): string {
  return formatWholeCurrency(value);
}

function fmtAxisCurrency(value: number): string {
  return formatWholeCurrency(value);
}

function fmtCurrencyExact(value: number): string {
  return formatWholeCurrency(value);
}

function fmtPct(value: number): string {
  return `${value}%`;
}

function fmtNumber(value: number): string {
  return value.toLocaleString();
}

export {
  fmtCurrency,
  fmtCurrencyFull,
  fmtAxisCurrency,
  fmtCurrencyExact,
  fmtPct,
  fmtNumber,
};
